module.exports = __webpack_public_path__ + "static/sample-19df1a5c213589216795c70ba2794aad.png";